import { render, staticRenderFns } from "./articleManagement.vue?vue&type=template&id=96814c00&"
import script from "./articleManagement.vue?vue&type=script&lang=js&"
export * from "./articleManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports